import { render, staticRenderFns } from "./SettingsRecipes.vue?vue&type=template&id=595e5c99"
import script from "./SettingsRecipes.vue?vue&type=script&lang=js"
export * from "./SettingsRecipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports